import { IconColor } from './iconsInterface'

export default function RecordingIcon({ color }: IconColor): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <path
        d="M1024.26 175.74C969.17 120.65 905 77.39 833.56 47.17 759.57 15.87 680.98 0 600 0S440.43 15.87 366.43 47.16c-71.44 30.21-135.62 73.48-190.7 128.57S77.38 294.99 47.16 366.43C15.87 440.43 0 519.02 0 600s15.87 159.57 47.16 233.57c30.21 71.44 73.48 135.62 128.57 190.7s119.26 98.35 190.7 128.57c74 31.3 152.58 47.16 233.57 47.16s159.57-15.87 233.57-47.16c71.44-30.21 135.62-73.48 190.7-128.57s98.35-119.26 128.57-190.7c31.3-74 47.16-152.58 47.16-233.57s-15.87-159.57-47.16-233.57c-30.21-71.44-73.48-135.62-128.57-190.7h0zM600 806.36c-113.79 0-206.35-92.57-206.35-206.35S486.22 393.66 600 393.66s206.35 92.57 206.35 206.35S713.78 806.36 600 806.36z"
        fill={color}
      />
    </svg>
  )
}
